module.exports = __webpack_public_path__ + "img/heart.c9ede823.svg";